import type { JSX } from 'react';
import { Link } from 'react-router-dom';

export function NotFoundPage(): JSX.Element {
  return (
    <div className="page page--narrow page--centred">
      <p className="not-found__code">404</p>
      <h1 className="page__title">This page is not on the map.</h1>
      <p className="page__lead">
        The link may be old, or the concept may not be written yet. Both are recoverable.
      </p>
      <div className="button-row">
        <Link to="/" className="btn btn--primary">
          Back to the start
        </Link>
        <Link to="/map" className="btn btn--secondary">
          Open the Math Map
        </Link>
      </div>
    </div>
  );
}
